import {
  post,
  get,
  deletee,
  put,
  convertToForm,
  content_types
} from 'services';
import { AxiosPromise } from 'axios';
import {
  IPrintRecord,
  IchangePassApiData,
  ILoginApiData,
  IUser,
  IgetUserApiData,
  IVerifyOtpApiData,
  IUserInfo,
  ITransactionInfo,
  ILoginActivity,
  pagination,
  sortByParams
} from 'types/index';

/**
 * @description your api helper functions defination goes here
 */

export type ILoginServiceResponse = {
  user: IUser;
  expiresIn: string;
  idToken: string;
};
export const loginService = (
  loginApiData: ILoginApiData
): AxiosPromise<ILoginServiceResponse> => {
  return post({
    subUrl: '/auth/login',
    data: loginApiData
  });
};

export const verifyOtpService = (
  params: IVerifyOtpApiData
): AxiosPromise<ILoginServiceResponse> => {
  return post({
    subUrl: '/auth/verify-2fa-code',
    data: params
  });
};

export const changePassService = (
  loginApiData: IchangePassApiData
): AxiosPromise<any> => {
  return post({
    subUrl: '/auth/changepassword',
    data: loginApiData
  });
};

export const getAllUsers = (
  getUserApiData: IgetUserApiData
): AxiosPromise<{ users: { rows: IUser[]; count: number } }> => {
  return get({
    subUrl: '/users/list',
    params: getUserApiData
  });
};

export type IdisableUserApiData = {
  id: string;
  isDeleted: boolean;
};

export const disableUserService = (
  disableUserApiData: IdisableUserApiData
): AxiosPromise<IUser[]> => {
  return deletee({
    subUrl: '/users',
    params: disableUserApiData
  });
};
export type IEditUserApiData = {
  id: string;
  credit: number;
  username: string;
  userType: string;
  region?: string;
  country_of_origin_id: string;
  subscription_start_date?: any;
  subscription_end_date?: any;
};
export const editUserService = (
  editUserApiData: IEditUserApiData
): AxiosPromise<IUser[]> => {
  return put({
    subUrl: '/users',
    data: editUserApiData
  });
};

export type IAddUserApiData = {
  username: string;
  email: string;
  credit: string;
  password: string;
  userType: string;
  region?: string;
  country_of_origin_id: string;
  subscription_start_date?: any;
  subscription_end_date?: any;
};
export const createUserService = (addUserApiData: IAddUserApiData) => {
  return post({
    subUrl: '/users',
    data: convertToForm(addUserApiData),
    headers: {
      ...content_types.multipart
    }
  });
};
export type userProfileRes = {
  data: IUser;
};

export const getUserProfile = (
  userId: string
): AxiosPromise<userProfileRes> => {
  return get({
    subUrl: '/users/profile',
    params: { userId }
  });
};

export const sendEmailWithCreds = (id: string): AxiosPromise<string> => {
  return post({
    subUrl: '/auth/send-email',
    data: { id }
  });
};

export type IgetUserCreditHistoryParams = {
  userId: string;
} & pagination;

export type IgetUserCreditHistoryRes = {
  data: {
    user_details: IUserInfo;
    total_count: number;
    credit_history: ITransactionInfo[];
  };
};

export const getUserCreditHistoryService = (
  getUserCreditHistoryParams: IgetUserCreditHistoryParams
): AxiosPromise<IgetUserCreditHistoryRes> => {
  return get({
    subUrl: '/users/credit-history',
    params: getUserCreditHistoryParams
  });
};

export const getUserLoginActivityService = (
  getUserLoginActivityParams: IgetUserCreditHistoryParams
): AxiosPromise<{ data: { rows: ILoginActivity[]; count: number } }> => {
  return get({
    subUrl: '/users/login-activity',
    params: getUserLoginActivityParams
  });
};

export type IgetUserCreatedRes = {
  data: {
    count: number;
    rows: IUser[];
  };
};

export type IgetUserCreatedParams = { userId: string } & pagination;

export const getUserCreatedService = (
  getUserCreatedParams: IgetUserCreatedParams
): AxiosPromise<IgetUserCreatedRes> => {
  return get({
    subUrl: '/users/created-users',
    params: getUserCreatedParams
  });
};

export type IGetUserPrintingHistoryRes = {
  data: {
    prints: IPrintRecord[];
    total: number;
  };
};

export type IGetUserPrintingHistoryParams = { user_id: string } & pagination &
  sortByParams;

export const getUserPrintingHistoryService = (
  getUserPrintParams: IGetUserPrintingHistoryParams
): AxiosPromise<IGetUserPrintingHistoryRes> => {
  return get({
    subUrl: '/prints/user-prints',
    params: getUserPrintParams
  });
};

export const getDefaultReport = () => {
  return get({
    subUrl: '/reporting/default'
  });
};

export const updateDefaultReport = (data: object): AxiosPromise<string> => {
  return post({
    subUrl: '/reporting/default',
    data: data
  });
};
